import parse from 'date-fns/parse';

function tryParseDate(input, formats) {
  for (let format of formats) {
    const date = parse(input, format, new Date());
    if (!isNaN(date.getTime())) {
      return date;
    }
  }
  return new Date('Invalid Date');
}

function parseCustomDate(input) {
  const formats = [
    'dd-MMM-yy',
    'yyyy MMM dd',
    'MMM/dd/yyyy',
    'dd/MM/yyyy',
    'dd/MMM/yyyy',
    'MMM dd yyyy',
    'yyyy-MM-dd',
  ];

  const fullFormats = formats.concat(formats.map(m => `${m} HH:mm:ss`)) // adding time


  input = input.toUpperCase();

  // Mapping custom or abbreviated month names to standard abbreviations
  const monthMappings = {
    'JA': 'JAN', 'FE': 'FEB', 'MR': 'MAR', 'AL': 'APR', 'MY': 'MAY', 'JN': 'JUN',
    'JL': 'JUL', 'AU': 'AUG', 'SE': 'SEP', 'OC': 'OCT', 'NO': 'NOV', 'DE': 'DEC'
  };

  // Replace all custom abbreviations with the correct ones
  input = input.replace(/\b(JA|FE|MR|AL|MY|JN|JL|AU|SE|OC|NO|DE)\b/g, matched => monthMappings[matched]);

  // Adjust for formats missing the day, assume the first day of the month
  if (input.match(/^[A-Z]+\/\d{4}$/)) {
    input = `01/${input}`;
  }

  return tryParseDate(input, fullFormats);
}

//Debugging


// console.log(parseCustomDate('07-Mar-26'), '07-Mar-26');
// console.log(parseCustomDate('2025 OC 05'), '2025 OC 05');
// console.log(parseCustomDate('2025 OC 02'), '2025 OC 02');
// console.log(parseCustomDate('2025 OC 18'), '2025 OC 18');
// console.log(parseCustomDate('2025 SE 28'), '2025 SE 28');
// console.log(parseCustomDate('2025 OC 17'), '2025 OC 17');
// console.log(parseCustomDate('OC/2025'), 'OC/2025');
// console.log(parseCustomDate('13/11/2025'), '13/11/2025');
// console.log(parseCustomDate('JAN 01 2023'), 'JAN 01 2023');
// console.log(parseCustomDate('Jan 01 2023'), 'Jan 01 2023');
// console.log(parseCustomDate('2025-10-17 00:00:00'), '2025-10-17 00:00:00');




const FND = (window.FND = window.FND || {});
FND.BUILDS = FND.BUILDS || {};
FND.BUILDS.Theme = FND.BUILDS.Theme || {};
FND.BUILDS.Theme.parseCustomDate = parseCustomDate;